export const appSettingConstants = {
  RETRIEVE_DATA_AREAS: 'RETRIEVE_DATA_AREAS',
  RETRIEVE_LANG: 'RETRIEVE_LANG',
  UPDATE_DATA_AREAS: 'UPDATE_DATA_AREAS',
  UPDATE_LANG: 'UPDATE_LANG',
  RETRIEVE_USER_STUDY_AREA: 'RETRIEVE_USER_STUDY_AREA',
  RETRIEVE_USER_LANG: 'RETRIEVE_USER_LANG',
}
